import { LabelModelType } from '@teinor/erp/types/company/config/label'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { DeleteRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCreateLabel from './ModalCreateLabel'
import ModalDeleteLabel from './ModalDeleteLabel'

interface ConfigLabelsProps extends ComponentWithPermissions { }

const ConfigLabels: React.FC<ConfigLabelsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('labels', 'Etiquetas'),
        newText: t('newLabel', 'Nueva etiqueta'),
    }

    return (
        <BaseScreenTable TableComponent={TableLabels} CreateModalComponent={ModalCreateLabel} DeleteModalComponent={ModalDeleteLabel} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableLabelsProps extends TableComponentProps { }

const TableLabels: React.FC<TableLabelsProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<LabelModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            width: 200,
            label: t('id', 'ID'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('label', 'Etiqueta'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('label', 'Etiqueta') }
            }
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                return <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='labels' columns={columns} getDataFrom='/api/app/config/label/getAllLabels' setTableInstance={setTableInstance} />
    )
}

export default ConfigLabels